import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';

const DataExtractionPage = () => {
    const navigate = useNavigate();

    const navigateToNewTask = () => {
        navigate('/data-extraction/new-task');
    };

    return (
            <Outlet context={{ navigateToNewTask }} />
    );
};

export default DataExtractionPage;
